import axios from '@/utils/axios'
import { record } from '@/utils/helpers'
export function createGroupTour (data) {
  return axios({
    url: '/group_tour',
    method: 'post',
    data
  })
}
export function getInfoFromRelated (id) {
  return axios({
    url: '/group_tour/' + id + '/basic_info',
    method: 'get'
  })
}
export function updateGroupTour (id, form) {
  record([id], 'update', 'group_tour')
  return axios({
    url: '/group_tour/' + id,
    method: 'put',
    data: form
  })
}
// /group_tour/status/<transaction_id>
export function getStatus (id) {
  return axios({
    url: '/group_tour/status/' + id,
    method: 'get'
  })
}
export function getSelectGroupTour (id) {
  return axios({
    url: '/group_tour/' + id,
    method: 'get'
  })
}

export function deleteGroupTour (transactionIdList) {
  record(transactionIdList, 'del', 'group_tour')
  return axios({
    url: '/group_tour',
    method: 'delete',
    data: { transaction_id_list: transactionIdList }
  })
}

export function getExchangeRate (data = { base: 'USD' }) {
  return axios({
    url: '/currency',
    method: 'post',
    data
  })
}

export function createTransactionGroup (data) {
  return axios({
    url: '/transaction_group',
    method: 'post',
    data: {
      transaction_id_list: data.transaction_id_list,
      create_by: data.create_by
    }
  })
}

export function addTransactionToGroup (data) {
  return axios({
    url: '/transaction_group/update',
    method: 'post',
    data: {
      transaction_id_list: data.transaction_id_list,
      transaction_group_id: data.transaction_group_id
    }
  })
}

export function fetchGroupList (data) {
  return axios({
    url: '/transaction_group/list',
    method: 'post',
    data: {
      create_by: data.create_by
    }
  })
}

export function searchGroupTour (form) {
  return axios({
    url: '/group_tour_transactions_list',
    method: 'post',
    data: form
  })
}

export function createGroup (transactionIdList, userName) {
  return axios({
    url: '/transaction_group',
    method: 'post',
    data: {transaction_id_list: transactionIdList, create_by: userName}
  })
}

export function getGroup (groupId) {
  return axios({
    url: '/transaction_group/' + groupId,
    method: 'get'
  })
}

export function leaveGroup (list, id, createBy) {
  return axios({
    url: '/transaction_group/update',
    method: 'put',
    // headers: {'Access-Control-Allow-Origin': '*'},
    data: {
      'transaction_id_list': list,
      'transaction_group_id': id,
      'create_by': createBy
    }
  })
}

export function delGroup (groupId) {
  // record([groupId], 'del', username)
  return axios({
    url: '/transaction_group',
    method: 'delete',
    // headers: {'Access-Control-Allow-Origin': '*'},
    data: {transaction_group_id: groupId}
  })
}



// WEBPACK FOOTER //
// ./src/api/groupTour.js